import axios from 'axios'
import { StaticImage } from 'gatsby-plugin-image'
import { withTranslation } from 'gatsby-plugin-react-i18next'
import { Loader } from 'google-maps'
import React, { Component } from 'react'
import { logAmplitudeEvent } from '../../../services/amplitude'
import LocationSearch from '../../location-search/LocationSearch'
import "./Guide.css"

const bear = {
  src: '../../../images/bear/noline.png',
  alt: 'Buxbear saying hi'
}
class Guide extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedCard: ''
    }
  }
  selectCard(id, name) {
    const { selectedCard } = this.state
    if (id === selectedCard) {
      this.setState({ selectedCard: '' })
    } else {
      this.setState({ selectedCard: id }, () => {
        const cardEl = document.querySelector('#hg-selected-content-wrap')
        cardEl &&
          window.scrollBy(0, cardEl.getBoundingClientRect().top - 100)
      })
      logAmplitudeEvent('Clicked on size & type guide', { storageType: name })
    }
  }
  scrollUp(card) {
    window.location.href = `${window.location.pathname}?selectedCard=${card}`
  }
  componentDidMount() {
    const { t } = this.props
    const selectedCardId = new URLSearchParams(window.location.search).get('selectedCardGuide')
    if (selectedCardId) {
      const selectedCard = t(`landing:guide.sections`, { returnObjects: true }).find(el => el.id === selectedCardId)
      selectedCard && this.selectCard(selectedCard.id, selectedCard.text)
    }
  }
  render() {
    const { t, location, noLocationSearch } = this.props
    const { selectedCard } = this.state
    const selectedCardContent = t(`landing:guide.sections`, { returnObjects: true }).find(el => el.id === selectedCard)
    return (
      <div className="home-guide-wrap">
        <div className="landing-anchor" id="guide" />
        <div className="hg-inner-wrap">
          <h2 className="hg-title">
            <span className="hg-title-dot dot" />
            <span className="hg-head">
              {location
                ? location.guideHeading
                : t(`landing:guide.head`)
              }
            </span>
          </h2>
          <div className={`hg-cards-wrap ${selectedCard ? 'has-selection' : ''}`}>
            <StaticImage 
              className="hg-bear"
              placeholder="none"
              {...bear} 
            />
            {t(`landing:guide.sections`, { returnObjects: true }).map(el => {
              return (
                <button
                  key={el.id}
                  className={`hg-card-wrap${el.id === selectedCard ? ' active' : ''}`}
                  onClick={() => this.selectCard(el.id, el.text)}
                >
                  <img 
                    className="hg-card-icon" 
                    {...el.icon}
                  />
                  <h3 className="hg-card-title">{el.text}</h3>
                </button>
              )
            })}
          </div>
          <div className="hg-selected-content-wrap" id="hg-selected-content-wrap">
            {selectedCardContent && (
              <div className="hg-selected-card-wrap">
                <div className="hg-selected-card-left">
                  <img
                    className="hg-selected-card-image"
                    {...selectedCardContent.content.image}
                  />
                </div>
                <div className="hg-selected-card-right">
                  <p className="hg-selected-card-title">{selectedCardContent.content.title}</p>
                  <div className="hg-selected-card-minimum-wrap">
                    {selectedCardContent.content.commonSizes && (
                      <p className="hg-selected-card-minimum-label">Most common:</p>
                    )}
                    {selectedCardContent.content.commonSizes && (
                      <h3 className="hg-selected-card-minimum-text">{selectedCardContent.content.commonSizes}</h3>
                    )}
                    {selectedCardContent.content.commonSizesAlt && (
                      <h4 className="hg-selected-card-minimum-text-alt">{selectedCardContent.content.commonSizesAlt}</h4>
                    )}
                  </div>
                  <p className="hg-selected-card-description">{selectedCardContent.content.description}</p>
                  {!noLocationSearch && (
                    <p className="hg-selected-card-label">
                      {t(`landing:guide.searchLabel`, { cardName: selectedCardContent.content.title.toLowerCase()})}
                    </p>
                  )}
                  {!noLocationSearch && (
                    <LocationSearch 
                      buttonText={selectedCardContent.content.button} 
                      selectedCard={selectedCard} 
                      showButton 
                      wrap 
                    />
                  )}
                  {noLocationSearch && (
                    <button 
                      className="submit-button"
                      onClick={() => this.scrollUp(selectedCardContent.id)}
                    >
                      {selectedCardContent.content.button}
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}
export default withTranslation(['landing'])(Guide)
